import { useState } from "react";
import { IconChevronDown } from "./Icons";

const FilterSection = ({ label, options, active, onChange }) => {
  const [open, setOpen] = useState(false);
  const hasActive = active !== "all";

  return (
    <div className="adv-filter-section">
      <button
        className={`adv-filter-header ${hasActive ? "has-active" : ""}`}
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <span>{label}</span>
        {hasActive && <span className="adv-filter-badge">1</span>}
        <span className="filter-icon">
          <IconChevronDown
            style={{
              transform: open ? "rotate(180deg)" : "rotate(0)",
              transition: "transform 0.25s",
            }}
          />
        </span>
      </button>
      <div className={`adv-filter-options ${open ? "open" : ""}`}>
        <div
          className={`adv-filter-option ${active === "all" ? "active" : ""}`}
          onClick={() => onChange("all")}
        >
          All
        </div>
        {options.map((opt) => (
          <div
            key={opt.id}
            className={`adv-filter-option ${active == opt.id ? "active" : ""}`}
            onClick={() => onChange(opt.id)}
          >
            {opt.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilterSection;
